// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Head from 'next/head';
import Router, { useRouter } from 'next/router';
import Breadcrumbs from '@/components/breadcrumbs';
import Tabs from '@/components/tabs';
import QueryDetails from '@/components/query/details';
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import Appointments from '@/components/shared-views/appointments';
import * as Enums from '@/utils/enums';
import Attachments from '@/components/shared-views/attachments';
import Communications from '@/components/shared-views/communications';
import ToastContext from '@/utils/toast-context';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import PS from '@/services/permission/permission-service';
import EmployeeService from '@/services/employee/employee-service';
import MessageService from '@/services/message/message-service';
import QueryService from '@/services/query/query-service';
import QueryStatusSummary from "@/PageComponents/QueryStatusSummary";
import CustomerChangeModal from "@/PageComponents/CustomerChangeModal";
import ManageLinksModal from "@/PageComponents/Links/ManageLinksModalV2";
import ManageLinksTableV2 from "@/PageComponents/Links/ManageLinksTableV2";
import {Box, Card, Flex} from "@mantine/core";
import ToolbarButtons from "@/PageComponents/Button/ToolbarButtons";
import {IconArchive, IconArchiveOff, IconDotsVertical, IconSquareCheck} from "@tabler/icons";
import {IconDeviceFloppy, IconSquareCheckFilled} from "@tabler/icons-react";
import {useElementSize} from "@mantine/hooks";
import ItemQuotesTable from "@/PageComponents/Table/Component Tables/ItemQuotesTable";
import ItemInvoicesTable from "@/PageComponents/Table/Component Tables/ItemInvoicesTable";
import ItemPurchasesTable from "@/PageComponents/Table/Component Tables/ItemPurchasesTable";
import {useQuery} from "@tanstack/react-query";
import QuoteDrawer from "@/PageComponents/Quote/QuoteDrawer";
import InvoiceDrawer from "@/PageComponents/Invoice/InvoiceDrawer";
import { createFileRoute } from '@tanstack/react-router'
import DetailsPageLoader from '@/components/details-page-loader'

function QueryPage() {

  const toast = useContext(ToastContext);

  const router = useRouter();
  const { id, tab } = router.query;
 // TODO(tanstack-router): verify router.query → useParams/useSearch

  const { data: queryData } = useQuery(
    ['query', id],
    () => QueryService.getQuery(id),
    { enabled: !!id }
  );

  const { data: customerData } = useQuery(
    ['customer', queryData?.CustomerID],
    () => Fetch.get({ url: `/Customer/${queryData.CustomerID}` }),
    { enabled: !!queryData?.CustomerID }
  );

  const { data: employeesData } = useQuery(
    ['employees', queryData?.StoreID],
    () => EmployeeService.getEmployees(queryData.StoreID),
    { enabled: queryData !== undefined }
  );

  const { data: customFieldsData } = useQuery(
    ['customFields', Enums.Module.Query],
    () => Fetch.get({ url: `/Option?module=${Enums.Module.Query}` })
  );

  const { data: showInventoryData } = useQuery(
    ['queryShowInventory'],
    () => Fetch.get({ url: '/Option/GetByOptionName?name=Query Show Inventory' })
  );

  const [customerPermission]= useState(PS.hasPermission(Enums.PermissionName.Customer));
  const [jobPermission] = useState(PS.hasPermission(Enums.PermissionName.Job));
  const [quotePermission] = useState(PS.hasPermission(Enums.PermissionName.Quote));
  const [invoicePermission] = useState(PS.hasPermission(Enums.PermissionName.Invoice));
  const [purchaseOrderPermission] = useState(PS.hasPermission(Enums.PermissionName.PurchaseOrder));
  const [appointmentPermission] = useState(PS.hasPermission(Enums.PermissionName.Appointment));
  const [pageTabs, setPageTabs] = useState<any[]>([]);

  const [selectedTab, setSelectedTab] = useState<any>(null);

  const [emptyCustomer, setEmptyCustomer] = useState(false);
  const [webFormGenerated, setWebformGenerated] = useState(false);
  const [customer, setCustomer] = useState<any>(null);
  const [contacts, setContacts] = useState<any[]>([]);
  const [contact, setContact] = useState<any>(null);
  const [locations, setLocations] = useState<any[]>([]);
  const [location, setLocation] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [messages, setMessages] = useState<any[]>([]);
  const [totalMessages, setTotalMessages] = useState(0);

  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const [showLinkJob, setShowLinkJob] = useState(false);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, saveQuery);

  const [query, setQuery] = useState<any>(null);

  function updateQuery(field: any, value: any) {
    let newQueryState = { ...query };
    newQueryState[field] = value;
    setQuery(newQueryState);
    setFormIsDirty(true);
  }

  const updateQueryInBulk = (items: any, markAsDirty = true) => {
    let temp = { ...query };
    for (var i = 0; i < items.length; i++) {
      temp[items[i].field] = items[i].value;
      if (items[i].field == "Employee") {
        setAppointmentEmployees([items[i].value]);
      }
    }
    setQuery(temp);
    setFormIsDirty(formIsDirty || markAsDirty);
  };

  const [appointmentEmployees, setAppointmentEmployees] = useState<any[]>([]);

  useEffect(() => {
    setQuery(null);
    setCustomer(null);
    setContacts([]);
    setContact(null);
    setLocations([]);
    setLocation(null);
    setSelectedTab(null);
    setAppointmentEmployees([]);
    setEmptyCustomer(false);
  }, [id]);

  useEffect(() => {
    if (queryData && !query) {
      setQuery(queryData);
      setContact(queryData.Contact);
      setLocation(queryData.Location);
      setAppointmentEmployees([queryData.Employee]);
    }
  }, [queryData]);

  useEffect(() => {
    if (customerData && !customer) {
      setCustomer(customerData);
      setContacts(customerData.Contacts ?? []);
      setLocations(customerData.Locations ?? []);
    }
  }, [customerData]);

  useEffect(() => {
    if (queryData && customer === null && Helper.isNullOrUndefined(queryData.CustomerID)) {
      setEmptyCustomer(true);
    }
  }, [queryData, customer]);

  useEffect(() => {
    if (selectedTab === null && router.isReady && queryData) {
      let initTab = 'Query Details';
      if (tab === 'communication') initTab = 'Messages';
      setSelectedTab(initTab);
    }
  }, [router.isReady, tab, queryData]);

  const fetchMessages = async () => {
    if (messages.length == 0) {
      const messagesRes = await MessageService.getMessages(query.ID, 0, 5);
      setMessages(messagesRes.Results);
      setTotalMessages(messagesRes.TotalResults);
    }
  };

  useEffect(() => {
    if (selectedTab === 'Messages') {
      fetchMessages();
    }
  }, [selectedTab]);

  const [quoteCount, setQuoteCount] = useState(0);
  const [invoiceCount, setInvoiceCount] = useState(0);
  const [purchaseOrderCount, setPurchaseOrderCount] = useState(0);
  const [appointmentCount, setAppointmentCount] = useState(0);
  const [jobCount, setJobCount] = useState(0);
  const [attachmentCount, setAttachmentCount] = useState(0);
  const [communicationCount, setCommunicationCount] = useState(0);
  const [statusSummaryCount, setStatusSummaryCount] = useState(0);

  const [countsToggle, setCountsToggle] = useState(false);

  const getCounts = async () => {
    let counts = await QueryService.getCounts(query.ID);
    setQuoteCount(counts.quoteCount);
    setInvoiceCount(counts.invoiceCount);
    setPurchaseOrderCount(counts.puchaseOrderCount);
    setAppointmentCount(counts.appointmentCount);
    setJobCount(counts.jobCount);
    setAttachmentCount(counts.attachmentCount);
    setCommunicationCount(counts.communicationCount);
    setStatusSummaryCount(counts.queryStatusChangesCount);

    setCountsToggle(!countsToggle);
  };

  useEffect(() => {
    buildUpPageTabs();
  }, [countsToggle]);

  const buildUpPageTabs = () => {
    let tabs = [
      { text: 'Query Details', count: '0' }];

    if (appointmentPermission)
      tabs.push({ text: 'Appointments', count: appointmentCount });

    if (jobPermission && jobCount > 0)
      tabs.push({ text: 'Jobs', count: jobCount });

    if (quotePermission && quoteCount > 0)
      tabs.push({ text: 'Quotes', count: quoteCount });

    if (invoicePermission && invoiceCount > 0)
      tabs.push({ text: 'Invoices', count: invoiceCount });

    if (purchaseOrderPermission && purchaseOrderCount > 0) {
      tabs.push({ text: 'Purchases', count: purchaseOrderCount });
    }

    tabs.push(
      { text: 'Summary', count: statusSummaryCount },
      { text: 'Attachments', count: attachmentCount },
      { text: 'Messages', count: communicationCount },
    );

    setPageTabs(tabs);
  };

  const checkForWebFormGeneratedQuery = () => {
    if (emptyCustomer) {
      if (query.QuerySource === Enums.QuerySource.Webform) {
        setWebformGenerated(true);
      }
    }
  };

  useEffect(() => {
    if (query?.ID) {
      getCounts();
      checkForWebFormGeneratedQuery();
    }
  }, [query?.ID]);

  const [showChangeCustomer, setShowChangeCustomer] = useState(false);

  const refreshQuery = async () => {
    await Helper.waitABit(500);
    Router.reload();
  };

  useEffect(() => {

    let opts = [
      { text: 'New Query', link: `CreateQuery` }];
    if (jobPermission) {
      opts.push({ text: 'Create Job', link: `CreateJob` });
      opts.push({ text: 'Link Job', link: `LinkJob` });
    }
    if (quotePermission)
      opts.push({ text: 'Create Quote', link: `CreateQuote` });
    if (invoicePermission)
      opts.push({ text: 'Create Invoice', link: 'CreateInvoice' });
    if (purchaseOrderPermission)
      opts.push({ text: 'Create Purchase Order', link: 'CreatePurchaseOrder' });
    if (customerPermission) {
      opts.push(
        { text: 'Open Customer', link: `OpenCustomer` },
        { text: 'Change Customer', link: `ChangeCustomer` },
      );
    }

    setOptionButtons(opts);

    getAccessStatus();

  }, []);

  const onAppointmentRefresh = () => {
    getCounts();
  };

  const onAttachmentRefresh = () => {
    getCounts();
  };

  useEffect(() => {
    if (customer) {
      setDisableOptions(accessStatus === Enums.AccessStatus.LockedWithAccess
        || accessStatus === Enums.AccessStatus.LockedWithOutAccess);
    }
  }, [customer]);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  const [disableOptions, setDisableOptions] = useState(accessStatus === Enums.AccessStatus.LockedWithAccess
    || accessStatus === Enums.AccessStatus.LockedWithOutAccess || emptyCustomer);

  const [optionButtons, setOptionButtons] = useState<any[]>([]);

  const {data: companyDetails} = useQuery(['companyDetails'], () => Fetch.get({url: '/Company'}))
  const [selectedQuote, setSelectedQuote] = useState<any>(null)
  const [createNewQuote, setCreateNewQuote] = useState(false)
  const [createNewCopyQuote, setCreateNewCopyQuote] = useState<any>(null)
  const [selectedInvoice, setSelectedInvoice] = useState<any>(null)
  const [createNewInvoice, setCreateNewInvoice] = useState(false)
  const [createNewCopyInvoice, setCreateNewCopyInvoice] = useState<any>(null)

  const optionsClick = async (link: any) => {

    let routeChange = true;
    if (formIsDirty) {
      routeChange = await saveQuery(routeChange);
    }

    if (routeChange) {
      switch (link) {
        case 'CreateQuery':
          Helper.nextRouter(Router.push, `/query/create`);
          break;
        case 'CreateJob':
          Helper.nextRouter(Router.push, `/job/create?module=${Enums.Module.Query}&moduleID=${query.ID}&customerID=${customer.ID}`);
          break;
        case 'LinkJob':
          setShowLinkJob(true)
          break;
        case 'CreateQuote':
          setCreateNewQuote(true)
          break;
        case 'CreateInvoice':
          setCreateNewInvoice(true)
          break;
        case 'CreatePurchaseOrder':
          Helper.nextRouter(Router.push, `/purchase/create?module=${Enums.Module.Query}&moduleID=${query.ID}`);
          break;
        case 'OpenCustomer':
          Helper.nextRouter(Router.push, `/customer/[id]`, `/customer/${customer.ID}`);
          break;
        case 'ChangeCustomer':
          setShowChangeCustomer(true);
          break;
        default:
          break;
      }
    }
  };

  const [inputErrors, setInputErrors] = useState<any>({});

  const [triggerSaveComment, setTriggerSaveComment] = useState(0);
  async function submitComment() {
    setTriggerSaveComment((x: any) => x + 1);
  }

  const [submitState, setSubmitState] = useState('none')

  async function saveQuery(routeChange = false) {
    setSaving(true);
    setSubmitState('onSubmit')
    setTimeout(() => {setSubmitState('none')}, 100)
  }

  const [closing, setClosing] = useState(false);

  async function closeQuery() {
    setClosing(true);

    const queryClose = await QueryService.closeQuery(query.ID, toast);

    if (queryClose.ID) {
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const queryCloseInner = await QueryService.openQuery(query.ID);
          setQuery(queryCloseInner);
          setFormIsDirty(false);
        },
        message: 'Query closed successfully',
        show: true,
        type: 'success'
      })
      setQuery(queryClose);
      setFormIsDirty(false);
    }

    setClosing(false);
  }

  async function openQuery() {
    setClosing(true);

    const queryOpen = await QueryService.openQuery(query.ID, toast);

    if (queryOpen.ID) {
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const queryCloseInner = await QueryService.closeQuery(query.ID);
          setQuery(queryCloseInner);
          setFormIsDirty(false);
        },
        message: 'Query opened successfully',
        show: true,
        type: 'success'
      })
      setQuery(queryOpen);
      setFormIsDirty(false);
    }

    setClosing(false);
  }

  const [archiving, setArchiving] = useState(false);
  async function archiveQuery() {
    setArchiving(true);

    const queryPut = await QueryService.archiveQueryToggle(query.ID, toast);

    if (queryPut.ID) {
      const message = queryPut.IsArchived ? 'Query archived successfully' : 'Query un-archived successfully'
      toast.setToast!!!({
        action: 'Undo',
        actionFunc: async function () {
          const queryPutInner = await QueryService.archiveQueryToggle(query.ID);
          setQuery(queryPutInner);
          setFormIsDirty(false);
        },
        message: message,
        show: true,
        type: 'success'
      })
      setQuery(queryPut);
      setFormIsDirty(false);
    }

    setArchiving(false);
  }

  const {height: toolbarHeight, ref: toolbarRef} = useElementSize()

  if (!query || selectedTab === null) return (
    <DetailsPageLoader
      tabWidths={[115, 110, 55, 65, 75, 85, 75, 100, 120]}
      actionWidths={[90, 90, 120, 65]}
    />
  );

  return (
    <Box >
      <Head><title>{query.QueryCode} | Queries</title></Head>

      <QuoteDrawer
          customerID={!!createNewCopyQuote ? undefined : customer?.ID}
          module={!!createNewCopyQuote ? undefined : Enums.Module.Query}
          moduleID={!!createNewCopyQuote ? undefined : query.ID}
          quote={selectedQuote}
          isNew={createNewQuote}
          show={createNewQuote || !!selectedQuote}
          onClose={
            () => {
              setSelectedQuote(null)
              setCreateNewQuote(false)
              setCreateNewCopyQuote(null)
            }
          }
          onSaved={() => {
            getCounts()
          }}
          onCreated={(q: any, close: any) => {
            if(!close) {
              setSelectedQuote(q)
            }
            setCreateNewQuote(false)
            setCreateNewCopyQuote(null)
            getCounts()
          }}
          accessStatus={accessStatus}
          company={companyDetails}
          copyFromQuote={createNewCopyQuote}
          onCopyToQuote={(q: any) => {
            setCreateNewQuote(true)
            setSelectedQuote(null)
            setCreateNewCopyQuote(q)
          }}
          onCreateNew={
            () => {
              setCreateNewQuote(true)
              setSelectedQuote(null)
              setCreateNewCopyQuote(null)
            }
          }
          setIsNew={setCreateNewQuote}
      />

      <InvoiceDrawer
          customerID={!!createNewCopyInvoice ? undefined : customer?.ID}
          module={!!createNewCopyInvoice ? undefined : Enums.Module.Query}
          moduleID={!!createNewCopyInvoice ? undefined : query.ID}
          invoice={selectedInvoice}
          isNew={createNewInvoice}
          show={createNewInvoice || !!selectedInvoice}
          onClose={
            () => {
              setSelectedInvoice(null)
              setCreateNewInvoice(false)
              setCreateNewCopyInvoice(null)
            }
          }
          onSaved={() => {
            getCounts()
          }}
          onCreated={(q: any, close: any) => {
            if(!close) {
              setSelectedInvoice(q)
            }
            setCreateNewInvoice(false)
            setCreateNewCopyInvoice(null)
            getCounts()
          }}
          accessStatus={accessStatus}
          company={companyDetails}
          copyFromInvoice={createNewCopyInvoice}
          onCopyToInvoice={(q: any) => {
            setCreateNewInvoice(true)
            setSelectedInvoice(null)
            setCreateNewCopyInvoice(q)
          }}
          onCreateNew={
            () => {
              setCreateNewInvoice(true)
              setSelectedInvoice(null)
              setCreateNewCopyInvoice(null)
            }
          }
          setIsNew={setCreateNewInvoice}
      />

      <ManageLinksModal
          show={showLinkJob}
          onClose={() => setShowLinkJob(false)}
          onSuccess={() => {
            setShowLinkJob(false);
            setSelectedTab('Jobs');
            getCounts();
          }}
          onChange={getCounts}
          item={query}
          itemModule={Enums.Module.Query}
          itemDocNumKey={'QueryCode'}
          linkItemModule={Enums.Module.JobCard}
          linkType={Enums.LinkType.JobsToQueries}
          linkItemDocNumKey={'JobCardNumber'}
          linkItemNumber={1}
          title={'Link a Job to Query ' + query.QueryCode}
          linkNoun={'Job'}
          linkNounMultiple={'Jobs'}
          noItemsText={'There are currently no available jobs for ' + query.CustomerName}
      />

      <Box mt={'md'} px={'sm'} mb={0} ref={toolbarRef}>
        <Flex>
          <Breadcrumbs currPage={{ text: query.QueryCode, link: `/query/${query.ID}`, type: 'query-show' }} />
          <ToolbarButtons
              buttonGroups={[
                [{
                  type: 'menu',
                  disabled: disableOptions,
                  breakpoint: 1100,
                  icon: <IconDotsVertical />,
                  action: optionsClick,
                  text: 'Options',
                  legacyOptions: optionButtons,
                },],
                [
                  {
                    breakpoint: 850,
                    type: 'button',
                    icon: query.IsArchived ? <IconArchiveOff color={'var(--mantine-color-yellow-1)'}/> :
                        <IconArchive color={'var(--mantine-color-yellow-7)'}/>,
                    isBusy: archiving,
                    disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
                    onClick: archiving ? null : archiveQuery,
                    variant: query.IsArchived ? 'filled' : 'outline',
                    color: query.IsArchived ? 'gray' : 'gray.6',
                    children: [
                      (
                          query.IsArchived ? (archiving ? "Un-archiving" : "Archived") : (archiving ? "Archiving" : "Archive")
                      )
                    ]
                  },
                  {
                    breakpoint: 850,
                    type: 'button',
                    icon: query.IsClosed ? <IconSquareCheckFilled color={'var(--mantine-color-green-2)'} /> : <IconSquareCheck color={'var(--mantine-color-green-6)'} />,
                    isBusy: closing,
                    onClick: closing ? null : (query.IsClosed ? openQuery : closeQuery),
                    variant: query.IsClosed ? 'filled' : 'outline',
                    color: query.IsClosed ? 'gray' : 'gray.6',
                    disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
                    children: [query.IsClosed ? (closing ? "Opening Query" : "Query Closed") : (closing ? "Closing" : "Close Query")],
                  }
                ],
                [
                  {
                    show: !query.IsClosed,
                    breakpoint: 480,
                    type: 'button',
                    icon: <IconDeviceFloppy />,
                    isBusy: saving,
                    onClick: saving ? null : () => saveQuery(false),
                    disabled: accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess,
                    children: [saving ? "Saving" : "Save"],
                  }
                ]
              ]}
          />

        </Flex>
        <Box mt={{base: 'sm', lg: 0}} mb={0}>
          <Tabs selectedTab={selectedTab} setSelectedTab={setSelectedTab}
                tabs={pageTabs} useNewTabs />
        </Box>
      </Box>

      <Box
          bg={'gray.1'}
          py={{base: 5, xs: 8, sm: 'md'}}
          px={{base: 5, xs: 8}}
          mih={`calc(100vh - ${(toolbarHeight ? (toolbarHeight + 68) : 166)}px)`}
      >
        <Card
            p={'md'}
            px={{base: 1, xs: 5, sm: 'sm'}}
            radius={'md'}
        >
          <Box style={{ display: selectedTab === 'Query Details' ? 'block' : 'none' }}>
            <QueryDetails
                query={query}
                updateQuery={updateQuery}
                updateQueryInBulk={updateQueryInBulk}
                queryPriorities={Enums.getEnumItems(Enums.QueryPriority, false)}
                employees={employeesData?.Results ?? []}
                triggerSaveComment={triggerSaveComment}
                customFields={customFieldsData?.Results ?? []}
                customer={customer}
                setCustomer={setCustomer}
                emptyCustomer={emptyCustomer}
                webformGenerated={webFormGenerated}
                setWebformGenerated={setWebformGenerated}
                contacts={contacts}
                setContacts={setContacts}
                contact={contact}
                setContact={setContact}
                locations={locations}
                setLocations={setLocations}
                location={location}
                setLocation={setLocation}
                inputErrors={inputErrors}
                accessStatus={accessStatus}
                showInventory={!!showInventoryData}
                onSubmitState={() => setSaving(false)}
                onSaved={(query: any) => {
                  setQuery(query)
                  setSaving(false)
                }}
                setSubmitState={submitState}
            />
          </Box>

          {selectedTab !== 'Query Details' && (() => {
            switch (selectedTab) {
              case 'Jobs':
                return <Box>
                  <ManageLinksTableV2
                      title='Linked Jobs'
                      item={query}
                      itemModule={Enums.Module.Query}
                      itemDocNumKey={'QueryCode'}
                      linkItemModule={Enums.Module.JobCard}
                      linkType={Enums.LinkType.JobsToQueries}
                      linkItemNumber={1}
                      linkItemDocNumKey={'JobCardNumber'}
                      onChange={(links: any) => getCounts()}
                      onNoItems={() => {
                        setSelectedTab('Query Details')
                        getCounts()
                      }}
                      countValue={jobCount}
                  />
                </Box>;
              case 'Quotes':
                return <ItemQuotesTable module={Enums.Module.Query} itemId={query.ID} customerId={customer ? customer.ID : null} accessStatus={accessStatus}
                                        onUpdated={getCounts} />;
              case 'Invoices':
                return <ItemInvoicesTable module={Enums.Module.Query} itemId={query.ID} customerId={customer ? customer.ID : null} accessStatus={accessStatus} />;
              case 'Purchases':
                return <ItemPurchasesTable module={Enums.Module.Query} itemId={query.ID} customerId={customer ? customer.ID : null} accessStatus={accessStatus} />;
              case 'Appointments':
                return <Appointments topMargin={false} module={Enums.Module.Query} moduleID={query.ID} customerID={customer ? customer.ID : null} accessStatus={accessStatus}
                                     onRefresh={onAppointmentRefresh} selectedStore={query.Store} selectedEmployees={appointmentEmployees} />;
              case 'Summary':
                return <QueryStatusSummary queryId={query.ID} />
              case 'Attachments':
                return <Attachments topMargin={false} displayName={query.QueryCode} itemId={query.ID} module={Enums.Module.Query} onRefresh={onAttachmentRefresh} accessStatus={accessStatus} />;
              case 'Messages':
                return <Communications topMargin={false} itemId={query.ID} module={Enums.Module.Query} customerID={customer ? customer.ID : null} selectedContact={contact} accessStatus={accessStatus} />;
              default:
                return null;
            }
          })()}
        </Card>
      </Box>

      {
          showChangeCustomer &&
          <CustomerChangeModal open={showChangeCustomer}
                               onClose={() => setShowChangeCustomer(false)}
                               currentItem={query}
                               accessStatus={accessStatus}
                               onCustomerChanged={refreshQuery}
          />
      }

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
      .row {
        display: flex;
      }
      .actions {
        display: flex;
      }
      .actions :global(.button){
        margin-left: 0.5rem;
        margin-top: 0;
        padding: 0 1rem;
        white-space: nowrap;
      }
    `}</style>
    </Box>
  );
}

export default QueryPage;

export const Route = createFileRoute('/_authenticated/query/$id')({ component: QueryPage })
